import { Card, CardSection, createStyles } from '@mantine/core';

const useStyles = createStyles(
	(theme, { withBorder }: { withBorder: boolean }) => ({
		stackContainer: {
			border: withBorder
				? `1px solid ${theme.other.getColor('border/secondary/default')}`
				: undefined,
			fontSize: theme.fontSizes.xs,
			color: theme.other.getColor('text/secondary/default'),
		},
	})
);

interface PolicySectionProps {
	title?: string | React.ReactNode;
	content: React.ReactNode;
	footer?: React.ReactNode;
	spacing?: boolean;
	radius?: string | number;
	withBorder?: boolean;
}

export default function PolicySection({
	title,
	content,
	footer,
	spacing = true,
	radius = 'md',
	withBorder = true,
}: PolicySectionProps) {
	const { classes, theme } = useStyles({ withBorder });

	return (
		<Card radius={radius} className={classes.stackContainer}>
			{title && (
				<CardSection
					sx={{
						backgroundColor: theme.other.getColor('fill/secondary/default'),
					}}
					p="xs"
				>
					{title}
				</CardSection>
			)}
			<CardSection p={spacing ? theme.spacing.md : 0}>{content}</CardSection>
			{footer && (
				<CardSection
					sx={{
						backgroundColor: theme.other.getColor('fill/secondary/default'),
					}}
				>
					{footer}
				</CardSection>
			)}
		</Card>
	);
}
